/**
 * The string values should match with those in OG:
 * https://gitlab.com/doxyme/app/doxyme-frontend/-/blob/qa/src/app/common/services/doxy-analytics/tracks/video-session-end.ts
 */
export enum CallEndReason {
  /**
   * Call stopped for provider because the patient left.
   */
  PatientLeft = 'PATIENT_LEFT',

  /**
   * Call stopped for patient because the provider left.
   */
  ProviderLeft = 'DOCTOR_LEFT',

  /**
   * User canceled the call by their own initiative.
   */
  Cancel = 'CANCEL',

  /**
   * Call stopped for patient because they were transferred to a new room.
   */
  TransferToNewRoom = 'TRANSFER_TO_NEW_ROOM',

  /**
   * Patient left call before provider joined call.
   * No other participants joined.
   */
  Timeout = 'TIMEOUT',

  /**
   * Unknown or unhandled case.
   */
  Default = 'DEFAULT',

  /**
   * User closed their window/tab/browser.
   */
  Unload = 'BEFORE_UNLOAD',

  /**
   * Call stopped for patient because provider has removed him from the call.
   */
  RemovedFromRoom = 'REMOVED_FROM_ROOM',

  /**
   * Provider ended call for on hold patient
   */

  HangUpOnHold = 'HANG_UP_ON_HOLD',

  /**
   * Outbound SIP phone call ended because the patient line was busy.
   */
  PhonePatientBusy = 'PHONE_PATIENT_BUSY',

  /**
   * Outbound SIP phone call ended because the patient did not answer.
   */
  PhonePatientUnanswered = 'PHONE_PATIENT_UNANSWERED',
}
